import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// import JS files
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import MuiButton from "../../../shares/MuiButton";

const AdminReportsPrintReqInvReg = () => {
  const navigate = useNavigate();
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const [requestList, setRequestList] = useState([]);

  const getRequestListApi = useFetch({
    method: "get",
    url: `User_Service/${useUserData.username}/admin_get_report_provider_request`,
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const componentRef = useRef();

  return (
    <div className="my-4">
      <div className="flex justify-between items-center mx-8">
        <span className="text-sm">برای دانلود فایل PDF کلیک کنید.</span>
        <div className="flex">
          <ReactToPrint
            trigger={() => {
              return (
                <MuiButton
                  variant="contained"
                  color="primary"
                  text="دانلود فایل PDF"
                  size="small"
                  //    icon={<ModeEditIcon />}
                />
              );
            }}
            content={() => componentRef.current}
          />
          <div className="mr-4">
            <MuiButton
              onClick={() => navigate(-1)}
              variant="outlined"
              color="secondary"
              text="بازگشت"
              size="small"
              icon={<ArrowBackIcon />}
            />
          </div>
        </div>
      </div>

      <div
        className="printTable mx-8"
        ref={componentRef}
        style={{ direction: "rtl" }}
      >
        <div className="text-center mt-8">
          <span className="font-bold">درخواست ها، موجودی و تعداد ثبت شده النگوها</span>
        </div>
        <div className="border rounded-md mt-4 overflow-hidden">
          <div className="flex justify-between">
            <div className="basis-1/2  text-center py-1 ">
              <span className="text-sm text-myblue-100">ردیف</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">کد</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">النگو</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">سن</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">رنگ</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> تولیدکننده</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> یک</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> دو</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> سه</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> چهار</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> پنج</span>
            </div>
            <div className=" basis-1/2 text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> شش</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> ثبتی یک</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> ثبتی دو</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> ثبتی سه</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> ثبتی چهار</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> ثبتی پنج</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> ثبتی شش</span>
            </div>
          </div>

          {requestList.map((item, index) => {
            return [
              <>
                <div className="printTableTr flex justify-between">
                  <div className="basis-1/2 border-t  text-center py-1">
                    <span className="text-sm text-myblue-100">{index + 1}</span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">{item.code}</span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.show_name}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.gender == "woman" ? "زنانه" : "بچه گانه"}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.color == "yellow" ? "زرد" : "سفید"}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">{item.name}</span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.total_bangle_stock_with_request.size_one_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.total_bangle_stock_with_request.size_two_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.total_bangle_stock_with_request.size_three_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.total_bangle_stock_with_request.size_four_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.total_bangle_stock_with_request.size_five_num}
                    </span>
                  </div>
                  <div className=" basis-1/2 border-t text-center py-1 border-r">
                    <span className="text-sm text-myblue-100">
                      {item.total_bangle_stock_with_request.size_six_num}
                    </span>
                  </div>

                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.request_extra.size_one_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.request_extra.size_two_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.request_extra.size_three_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.request_extra.size_four_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.request_extra.size_five_num}
                    </span>
                  </div>
                  <div className=" basis-1/2 border-t text-center py-1 border-r">
                    <span className="text-sm text-myblue-100">
                      {item.request_extra.size_six_num}
                    </span>
                  </div>
                </div>
                {index == 21 ? <div className="break"></div> : undefined}
              </>,
            ];
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminReportsPrintReqInvReg;
